import { Navigate, useLocation, useParams } from "react-router-dom";
import { appRoutes } from "@/app/router/appRoutes";
import {
  AGENT_PROJECT_ID_SEARCH_PARAM,
  AGENT_ROUTINE_IMPORT_SEARCH_PARAM,
  AGENT_SEARCH_PARAM,
  AGENT_SKILL_IMPORT_SEARCH_PARAM,
  AGENT_TASK_ID_SEARCH_PARAM,
  AgentSurfaceId,
} from "@/store/agent-overlay/types";
import type { AgentEntityRouteParamName } from "@/store/agent-overlay/types";
import { useAppStore } from "@/store";
import {
  withoutAgentIdentitySearchParams,
  withoutAgentSearchParams,
  withoutSettingsSearchParams,
} from "@/store/overlay-search-params";

interface AgentRedirectProps {
  surfaceId: AgentSurfaceId;
  routeParamName?: AgentEntityRouteParamName;
}

const AGENT_ROUTE_PARAM_TO_SEARCH_PARAM: Record<AgentEntityRouteParamName, string> = {
  projectId: AGENT_PROJECT_ID_SEARCH_PARAM,
  taskId: AGENT_TASK_ID_SEARCH_PARAM,
  skillImportId: AGENT_SKILL_IMPORT_SEARCH_PARAM,
  verificationToken: AGENT_ROUTINE_IMPORT_SEARCH_PARAM,
};

export const AgentRedirect = ({ surfaceId, routeParamName }: AgentRedirectProps) => {
  const { store } = useAppStore();
  const location = useLocation();
  const routeParams = useParams();
  const sourceSearchParams = new URLSearchParams(location.search);
  const searchParams = withoutAgentIdentitySearchParams({
    searchParams: withoutSettingsSearchParams({ searchParams: sourceSearchParams }),
  });
  const isSurfaceEnabled = store.agentOverlay.isSurfaceEnabled(surfaceId);

  if (!isSurfaceEnabled) {
    const nonAgentSearchParams = withoutAgentSearchParams({ searchParams });
    const query = nonAgentSearchParams.toString();
    return <Navigate to={`${appRoutes.notesList({}).path}${query ? `?${query}` : ""}`} replace />;
  }

  searchParams.set(AGENT_SEARCH_PARAM, surfaceId);

  if (routeParamName) {
    const routeParamValue = routeParams[routeParamName];

    if (!routeParamValue) {
      searchParams.set(AGENT_SEARCH_PARAM, AgentSurfaceId.Overview);

      return <Navigate to={`${appRoutes.notesList({}).path}?${searchParams.toString()}`} replace />;
    }

    searchParams.set(AGENT_ROUTE_PARAM_TO_SEARCH_PARAM[routeParamName], routeParamValue);
  }

  return <Navigate to={`${appRoutes.notesList({}).path}?${searchParams.toString()}`} replace />;
};
